import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../../styles/Login.css';

function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setMessage('❌ Passwords do not match');
            setIsError(true);
            return;
        }

        try {
            console.log('📤 Sending token to backend:', token);

            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/reset-password/${token}`, {
                password: newPassword
            });
            setMessage(res.data.message || '✔️ Password reset successfully!');
            setIsError(false);

            // Auto redirect after 3 seconds
            setTimeout(() => navigate('/'), 3000);
        } catch (error) {
            const msg = error.response?.data?.message || '❌ Failed to reset password';
            setMessage(msg);
            setIsError(true);
        }
    };

    return (
        <div className="login-container">
            <div className="login-form-wrapper">
                <h3 className="mb-4">Reset Your Password</h3>

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label>New Password</label>
                        <div className="input-group">
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                className="form-control"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                            <span
                                className="input-group-text"
                                onClick={() => setPasswordVisible(!passwordVisible)}
                                style={{ cursor: 'pointer' }}
                            >
                                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label>Confirm Password</label>
                        <input
                            type={passwordVisible ? 'text' : 'password'}
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-secondary px-4"
                            onClick={() => navigate('/')}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary px-4">
                            Reset Password
                        </button>
                    </div>

                    {message && (
                        <div
                            className="mt-3"
                            style={{
                                padding: '10px',
                                backgroundColor: isError ? '#f8d7da' : '#d4edda',
                                color: isError ? '#721c24' : '#155724',
                                border: '1px solid',
                                borderColor: isError ? '#f5c6cb' : '#c3e6cb',
                                borderRadius: '5px',
                                textAlign: 'center',
                                fontSize: '0.95rem'
                            }}
                        >
                            {message}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;
